import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MatButtonModule } from '@angular/material/button';

import { HeaderModule } from '../shared/components/header/header.module';
import { FooterModule } from '../shared/components/footer/footer.module';

import { PageNotFoundComponent } from './page-not-found.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    
    MatButtonModule,
    HeaderModule,
    FooterModule
  ],
  exports: [
    PageNotFoundComponent
  ],
  providers: [
  ],
  declarations: [
    PageNotFoundComponent
  ]
})
export class PageNotFoundModule { }
